module.exports = __webpack_public_path__ + "static/img/DO@2x.fc4cfb45.jpg";